// extracted by mini-css-extract-plugin
export var closeButton = "modal-module--close-button--4SohI";
export var modalBackground = "modal-module--modal-background--IyPbB";
export var modalContent = "modal-module--modal-content--mMOX8";